import { render } from "./Charge.vue?vue&type=template&id=b0fad784"
import script from "./Charge.vue?vue&type=script&lang=js"
export * from "./Charge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v1/Charge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0fad784"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0fad784', __exports__)) {
    api.reload('b0fad784', __exports__)
  }
  
  module.hot.accept("./Charge.vue?vue&type=template&id=b0fad784", () => {
    api.rerender('b0fad784', render)
  })

}


export default __exports__